import DataProvider from "~/data-provider";
import { addListener, removeListener } from "~/lib/signals";
import { openCadastralEntityWasm } from "./cadastral";

export interface ILookupCadastralData {
	id: number;
	extend: {
		link?: Array<{ text: string; url: string; }>;
	};
	geom: {
		data: Array<string>;
		type: "path";
	};
}

export default class DataProviderCadastral extends DataProvider {
	_changeWidthSignal: string;

	_cache: {[key: number]: ILookupCadastralData;};

	constructor() {
		super();
		this._changeWidthSignal = "";
		this._cache = {};
	}

	isActive() {
		return this._active;
	}

	enable() {
		if (this._active) {
			return null;
		}

		this._changeWidthSignal = addListener({}, "width-change", () => {
			const geometries = this._layers[0].getFilters()?.geometry?.[0]?.layer?.getGeometries();

			for (const id in geometries) {
				if (geometries[id]) {
					const geometry = geometries[id];

					geometry.setPath([geometry.getPath()]);
				}
			}
		});


		return super.enable();
	}

	disable() {
		if (!this._active) {
			return null;
		}

		this._cache = {};

		this._changeWidthSignal && removeListener(this._changeWidthSignal);

		this._changeWidthSignal = "";

		return super.disable();
	}

	openCadastral(id: number) {
		let find = false;

		if (id in this._cache) {
			openCadastralEntityWasm(this._cache[id]);
			find = true;
		}

		if (!find) {
			/* eslint-disable-next-line */
			console.error(`No cadastral data wasm - ${id}`);
		}
	}

	isIdCadastral(id: number) {
		return id in this._cache;
	}

	/**
	 * Máme všechny odpovědi, obejdeme vrstvy
	 */
	_done() {
		for (const response of this._responses) {
			const items: Array<ILookupCadastralData> = response.poi || [];

			for (const item of items) {
				if (!(item.id in this._cache)) {
					this._cache[item.id] = item;
				}
			}
		}

		super._done();
	}
}
